import { useEffect, useId, useState } from "react"
import { GFFieldComponentProps } from "eddev/integrations/gravityforms"
import { Input } from "./Input"

export function AddressGroup(props: GFFieldComponentProps<"address">) {
  const [values, setValues] = useState<any>({})
  const id = useId()

  useEffect(() => {
    if (values) {
      const sorted = Object.fromEntries(Object.entries(values).sort())
      props.set(sorted)
    }
  }, [values])

  const thirds = ["address-level2", "address-level1", "postal-code"]

  return (
    <div className={`flex flex-row flex-wrap gap-3 w-full`}>
      {Object.values(props.subfields)
        .filter((input) => input.visible)
        .map((input) => {
          return (
            <div
              key={input.name}
              data-address-component={input.name}
              className={`flex flex-col gap-2 w-full ${thirds.includes(input.autocomplete) ? `md:w-[calc((100%-(var(--spacing-3)*2))*(1/3))]` : ``}`}
            >
              <Input
                value={props.value?.[input.name] ?? ""}
                onChange={(e: any) =>
                  setValues((prevValues: any) => ({ ...prevValues, [input.name]: e.currentTarget.value }))
                }
                id={`${id}_${input.name}`}
              />
              <label id={`${id}_${input.name}`} className="type-label-s text-text">
                {input.label}
              </label>
            </div>
          )
        })}
    </div>
  )
}
